import { CriteriaOperationType } from '@models'
import { OrderType } from '@modules/common/models/enums'
import { IPermissions } from '@routes'
import { getAverageRating } from '@services/showroom/SAProductDetailsUtilities'
import { stores } from '@stores'
import cloneDeep from 'lodash/cloneDeep'
import { action, observable } from 'mobx'

export class ShowroomProductDetailStore {
  @observable isShowMoreAttributesOpen = false
  @observable processedProduct = null
  @observable userPermission: IPermissions = null
  @observable currentUser = null

  getOrderTypeWhereInput = (orderId, orderType) => {
    const doorOrder = {
      c8__Parent__: {
        VIPDoorOrder: {
          Id: {
            operation: CriteriaOperationType.EQ,
            value: orderId
          }
        }
      }
    }

    const clientOrder = {
      c8__Parent__: {
        VIPClientOrder: {
          Id: {
            operation: CriteriaOperationType.EQ,
            value: orderId
          }
        }
      }
    }

    if (orderType === OrderType.Client) {
      return clientOrder
    } else if (orderType === OrderType.Door) {
      return doorOrder
    } else {
      return [doorOrder, clientOrder]
    }
  }

  /**
   * where input for the order product
   */

  whereInputForOrderProduct = () => {
    const {
      nav: {
        queryParams: { orderType, bspId, orderId }
      }
    } = stores

    if (orderId && bspId) {
      return {
        GIV_VIPOrderProduct_BuyingSessionProduct_ref: {
          Id: {
            operation: CriteriaOperationType.EQ,
            value: bspId
          }
        },
        OR: this.getOrderTypeWhereInput(orderId, orderType)
      }
    }
    return null
  }

  @action setShowMoreAttributesOpen = isShowMoreAttributesOpen => {
    this.isShowMoreAttributesOpen = isShowMoreAttributesOpen
  }

  @action setProcessedProduct = processedProduct => {
    this.processedProduct = { ...processedProduct }
  }

  @action updateProcessedProductRating = (ratingTypeId: string, ratingValue: number) => {
    if (this.processedProduct?.ratings?.length) {
      const processedProduct = cloneDeep(this.processedProduct)
      const ratingToUpdate = processedProduct.ratings.findIndex(
        rating => ratingTypeId === rating.Id
      )
      if (-1 !== ratingToUpdate) {
        processedProduct.ratings[ratingToUpdate].Value = ratingValue
        processedProduct.averageRating = getAverageRating(processedProduct.ratings)
        this.setProcessedProduct(processedProduct)
      }
    }
  }
}

export const showroomProductDetailStore = new ShowroomProductDetailStore()
